import {Props} from './model';
import {Platform, View, TouchableOpacity, ViewStyle} from 'react-native';
import * as React from 'react';

import {Notification} from './components/notification';
import {useStyles} from '../../hooks/styles';
export default (props: Props) => {
  const styles = useStyles(() => ({
    container: {
      position: (Platform.OS === 'web' ? 'fixed' : 'absolute') as ViewStyle['position'],
      top: 50,
      left: 0,
      right: 0,
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 101,
      pointerEvents: 'box-none',
      paddingHorizontal: 24,
    },
  }));
  return (
    <View testID='snackbar' style={styles.container}>
      {props.notifications.map((item, index) => {
        if (!item.onClick) {
          return <Notification key={item.id} notification={item} />;
        }
        return (
          <TouchableOpacity
            key={item.id}
            testID={`snackbar-${index}-id`}
            onPress={() => {
              item.onClick?.();
              props.onCloseAdditional(item.id);
            }}>
            <Notification notification={item} />
          </TouchableOpacity>
        );
      })}
    </View>
  );
};
